import React, { useState } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem('loginDate', new Date().toISOString().split('T')[0]);
      navigate('/');
    } catch (err) {
      setError('Correo o contraseña incorrectos. Inténtalo de nuevo.');
      console.error(err);
    }
  };

  const handlePasswordReset = () => {
    const userEmail = prompt("Por favor, ingresa tu correo electrónico para enviarte el enlace de recuperación:");
    if (userEmail) {
      sendPasswordResetEmail(auth, userEmail)
        .then(() => {
          alert("Se ha enviado un enlace para restablecer tu contraseña a tu correo. ¡No olvides revisar la carpeta de spam!");
        })
        .catch((error) => {
          console.error("Error al enviar correo de recuperación:", error);
          alert("Hubo un error al intentar enviar el correo. Por favor, verifica que la dirección sea correcta.");
        });
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Itacate Minero</h1>
        <h2>Iniciar Sesión en el Dashboard</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="error-message">{error}</p>}
          <button type="submit">Entrar</button>
        </form>
        {/* --- INICIO DE LA MODIFICACIÓN 3: Añadimos el enlace --- */}
        <p className="forgot-password-link" onClick={handlePasswordReset}>
          ¿Olvidaste tu contraseña?
        </p>
        {/* --- FIN DE LA MODIFICACIÓN 3 --- */}
      </div>
    </div>
  );
};

export default LoginPage;